import React from 'react';

// ============================================================================
// Segmented — the form-controls standard for "one of a few MODES": joined
// buttons, one lit (Range | Clock, Board | Day, Local | Long distance).
// Two to four short words. For picking a VALUE (crew 2–8, truck size) use
// ChoiceKeys instead — separated keys read as values, joined ones as a
// mode switch (form-controls.md, "One of a few: A").
//
// items: [{ value, label, icon?, disabled?, title? }]; value; onChange(value)
// size: 'md' (40px) | 'sm' (32px); full: stretch to container width.
// ============================================================================

export default function Segmented({ items = [], value, onChange, size = 'md', full = false, disabled = false, ariaLabel, className = '' }) {
    const h = size === 'sm' ? 'h-8 px-3 text-[12px]' : 'h-10 px-3.5 text-[13px]';
    const cur = value === null || value === undefined ? '' : String(value);
    return (
        <div
            role="radiogroup"
            aria-label={ariaLabel}
            className={`${full ? 'flex w-full' : 'inline-flex'} rounded-lg border border-slate-200 overflow-hidden bg-white ${className}`}
        >
            {items.map((it, i) => {
                const on = String(it.value) === cur;
                return (
                    <button
                        key={String(it.value)}
                        type="button"
                        role="radio"
                        aria-checked={on}
                        title={it.title}
                        disabled={disabled || it.disabled}
                        onClick={() => onChange?.(it.value)}
                        className={`${h} ${full ? 'flex-1' : ''} min-w-[44px] font-bold whitespace-nowrap inline-flex items-center justify-center gap-1.5 transition-colors ${
                            i > 0 ? 'border-l border-slate-200' : ''
                        } ${on ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'} focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-red-500/30 disabled:opacity-40 disabled:cursor-not-allowed`}
                    >
                        {it.icon && <span aria-hidden="true">{it.icon}</span>}
                        {it.label}
                    </button>
                );
            })}
        </div>
    );
}
